import React, { Component, Suspense } from "react";
import * as ReactDOM from "react-dom";
import { Link, Route } from "react-router-dom";
//import "bootstrap/dist/css/bootstrap.css";
import "./style.css";
import "./responsive.css";
import Head from "../layout/Head";
//import "./style.css";
import "./dental-designs.css";
import "./dental-designs-responsive.css";
//import './simple-line-icons.css'
import $ from "jquery";
// import config from "../config";
// import jwt from "jsonwebtoken";
//import logo from "../image/dentaldesigns/logo.png";
//import Booknow from "./dentalDesignsComponents/booknow";
// import { userSignUpCall, getuserauthentication } from "../service";
// import validator from "validator";
// import queryString from "query-string";
import { Helmet } from "react-helmet";
import Favicon from "react-favicon";
import Login from "../layout/login";
import Signup from "../layout/signup";
import ForgotPassword from "../layout/forgot-password";
import { apiCalling } from "../apiService";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import { Style } from "react-style-tag";
ReactGA.initialize(window.sessionStorage.getItem("googleId"));
ReactGA.pageview(window.location.pathname + window.location.search);
ReactPixel.init(window.sessionStorage.getItem("fbPixel"));
ReactPixel.pageView();
const PatientMenu = React.lazy(() => import("../home/patientMenu"));
const DoctorMenu = React.lazy(() => import("../home/doctorMenu"));
// const AdminMenu = React.lazy(()=> import("../home/adminMenu"));
const NotificationPopUp = React.lazy(() => import("../home/notificationPopup"));
const folderName = window.sessionStorage.getItem("homeName");
let themeCustomColor;
let theme_custom_color_data =
  window.sessionStorage.getItem("theme_custom_color");
if (theme_custom_color_data != null && theme_custom_color_data != "") {
  themeCustomColor = theme_custom_color_data.split("|");
} else {
  themeCustomColor = "";
}
export default class header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headerData: [],
      headerDataLink: [],
      SubList: [],
      userdropVisible: false,
      siteServices: [],
    };

    this.userdropClick = this.userdropClick.bind(this);
    this.userOutsideClick = this.userOutsideClick.bind(this);
  }
  userdropClick() {
    if (!this.state.userdropVisible) {
      document.addEventListener("click", this.userOutsideClick, false);
    } else {
      document.removeEventListener("click", this.userOutsideClick, false);
    }
    this.setState((prevState) => ({
      userdropVisible: !prevState.userdropVisible,
    }));
  }

  signOutPatientClick() {
    $(".loader").show();
    const logoutReq = {
      method: "POST",
      body: JSON.stringify({
        functionName: "logout",
        siteId: window.sessionStorage.getItem("siteId"),
        userId: window.sessionStorage.getItem("userId"),
      }),
    };

    apiCalling(logoutReq).then((data) => {
      if (data.success === "1") {
        const siteId = window.sessionStorage.getItem("siteId");
        sessionStorage.clear();
        window.sessionStorage.setItem("userId", "");
        window.sessionStorage.setItem("emailId", "");
        window.sessionStorage.setItem("userName", "");
        window.sessionStorage.setItem("isLogin", "");
        window.sessionStorage.setItem("role", "");
        const urlPath = window.location.origin.toString();
        window.sessionStorage.setItem("siteId", siteId);
        window.location.href = urlPath + "/SITEID-" + siteId;

        alert(data.successMessage);
      } else {
        alert("Logout Failed");
      }
      $(".loader").hide();
    });
  }
  userOutsideClick(e) {
    // ignore clicks on the component itself
    if (this.userNode) {
      if (this.userNode.contains(e.target)) {
        return;
      }
      this.userdropClick();
    }
  }
  componentWillMount() {
    const doctorDetails = {
      method: "POST",
      body: JSON.stringify({
        functionName: "getSiteDetails",
        siteId: window.sessionStorage.getItem("siteId"),
        siteUrl: window.sessionStorage.getItem("siteUrl"),
      }),
    };

    apiCalling(doctorDetails).then((data) => {
      if (data.success == "1") {
        this.setState({ headerData: data.siteDetailsData[0].headerData });
      }
    });

    this.headerLoading();
    this.loadService();
  }
  headerLoading() {
    //let headerData = JSON.parse(window.sessionStorage.getItem("headerData"));
    //this.setState({ headerDataLink: headerData });
    // this.setState({ SubList: [] });
    //alert(headerData);
    const headerDetails = {
      method: "POST",
      body: JSON.stringify({
        functionName: "headerLinksDetails",
        siteId: window.sessionStorage.getItem("siteId"),
      }),
    };

    apiCalling(headerDetails).then((data) => {
      if (data.success === "1") {
        this.setState({ headerDataLink: data.headerLinkContent });
        // this.setState({ headerDataLink: headerData });
        this.setState({ SubList: data.headerLinkContent.headerSubList });
      } else {
        //this.headerLoading();
      }
    });
  }
  menuClick() {
    $(".menu ul").slideToggle();
  }
  loginMenu() {
    // alert();
    $("#ForgotPasswordWrap").hide();
    $("#SignupWrap").hide();
    $("#signInWrapDiv").show();
    $(".mentalMenu").removeClass("mentalMenuActive");
    $(".mentalToggle").removeClass("mentalToggleActive");
    $(".mentalHeaderActive").toggle();
  }
  componentWillUpdate() {
    if (this.props.menuActive) {
      $(".menu_item").removeClass("mentalMenuAtive");
      $("#menu_" + this.props.menuActive).addClass("mentalMenuAtive");
    }
  }
  componentDidMount() {
    // this.lazyPageLoad("home", "");

    setInterval(async () => {
      $(".showMyName").html("Hi " + window.sessionStorage.getItem("userName"));
    }, 2000);
    $(".mentalToggle,.mentalHeaderActive").click(function () {
      $(".mentalMenu").toggleClass("mentalMenuActive");
      $(".mentalToggle").toggleClass("mentalToggleActive");
      $(".mentalHeaderActive").toggle();
    });

    //$("#signUpWrap,#signInWrap,#forgotPswdWrap").hide();
    $("#signoutMenu").hide();
    $(".patientMenuTop").hide();
    $(".doctorMenuTop").hide();
    // $(".layoutPatientMenuTop").hide();
    // $(".layoutDoctorMenuTop").hide();
    $("#loginMenu").click(function () {
      $("#signUpWrap").hide();
      $("#signInWrap").toggle();
      $("#forgotPswdWrap").hide();
    });
    $("#forgotPswd").click(function () {
      $("#SignupWrap").hide();
      $("#signInWrapDiv").hide();
      $("#ForgotPasswordWrap").show();
    });
    $("#signUp").click(function () {
      $("#signInWrapDiv").hide();
      $("#ForgotPasswordWrap").hide();
      $("#SignupWrap").show();
    });

    $(".signInWrap,#loginMenu").click(function (event) {
      event.stopPropagation();
    });
    if (window.sessionStorage.getItem("isLogin") == "true") {
      if (window.sessionStorage.getItem("role") == "ROLE_DOCTOR") {
        $(".doctorMenuTop").show();
      }
      if (window.sessionStorage.getItem("role") == "ROLE_USER") {
        $(".patientMenuTop").show();
      }
      // if(window.sessionStorage.getItem("role") == "ROLE_ADMIN") {
      //   window.location.href = "/admin/dashboard";
      // }
    }
    // if (window.sessionStorage.getItem("role") == "ROLE_DOCTOR") {
    //   $(".layoutDoctorMenuTop").show();
    // }
    // if (window.sessionStorage.getItem("role") == "ROLE_USER") {
    //   $(".layoutPatientMenuTop").show();
    // }

    $("#dropArrow").click(function () {
      $(".mentalSubMenu").toggle();
    });

    if (window.sessionStorage.getItem("reload") == "1") {
      //this.lazyPageLoad("home");
      // window.sessionStorage.setItem("reload", "0");
    }

    // $(".menu_item").click(function () {
    //   $(".menu_item").removeClass("mentalMenuAtive");
    //   $(this).addClass("mentalMenuAtive");
    // });

    $(".menu_item").click(function () {
      if ($(window).width() < 992) {
        $(this).children(".mentalSubMenu").slideToggle();
      } else {
      }
    });
  }

  menuClick() {
    $(".menu ul").slideToggle();
  }
  /**common function for all header */
  loadService() {
    const siteServices = JSON.parse(
      window.sessionStorage.getItem("siteServices")
    );
    if (siteServices) {
      this.setState({ siteServices: siteServices });
    } else {
    }
  }
  /**common function for all header */
  getServiceLink = (param) => {
    switch (param) {
      case "Video Chat":
        return [<a href="/home/doctor-list-main/3">Video Chat</a>];
      case "Messaging":
        return [<a href="/home/doctor-list-main/2">Text Chat</a>];
      case "Call a Doctor":
        return [<a href="/home/doctor-list-main/4">Audio Chat</a>];
      case "Book Appointment":
        return [<a href="/home/doctor-list-main/1">In-Person Appointment</a>];
    }
  };
  render() {
    $("a").on("click", function (event) {
      $("html, body").animate({ scrollTop: 0 }, "slow");
    });
    const urlPath = window.location.origin.toString();
    return (
      <div class="mentalHeader">
        {themeCustomColor.length > 0 ? (
          <Style>
            {`
:root {
--theme-color: ` +
              themeCustomColor[0] +
              `;
--common-color: ` +
              themeCustomColor[1] +
              `;
--theme-sub-color: ` +
              themeCustomColor[2] +
              `;
--theme-text-color: ` +
              themeCustomColor[3] +
              `;
--footer-bgcolor:` +
              themeCustomColor[4] +
              `;
--footer-textcolor: ` +
              themeCustomColor[5] +
              `;
--common-button-bgcolor: ` +
              themeCustomColor[6] +
              `;
--common-button-txtcolor: ` +
              themeCustomColor[7] +
              `;
--focus-input-color: ` +
              themeCustomColor[8] +
              `;
--theme-service-text-color: ` +
              themeCustomColor[9] +
              `;
--theme-login-bgcolor: ` +
              themeCustomColor[10] +
              `;
--theme-login-textcolor: ` +
              themeCustomColor[11] +
              `;
`}
          </Style>
        ) : (
          ""
        )}
        <Head
          script={[
            {
              async: "",
              src:
                "https://www.googletagmanager.com/gtag/js?id=" +
                window.sessionStorage.getItem("googleId"),
            },
            {
              data: `window.dataLayer = window.dataLayer || [];
                      function gtag(){dataLayer.push(arguments);}
                      gtag('js', new Date());
                      gtag('config', '${window.sessionStorage.getItem(
                "googleId"
              )}');`,
            },
            {
              data: `!function(f,b,e,v,n,t,s)
                      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                      n.queue=[];t=b.createElement(e);t.async=!0;
                      t.src=v;s=b.getElementsByTagName(e)[0];
                      s.parentNode.insertBefore(t,s)}(window, document,'script',
                      'https://connect.facebook.net/en_US/fbevents.js');
                      fbq('init', '${window.sessionStorage.getItem(
                "fbPixel"
              )}');
                      fbq('track', 'PageView');`,
            },
            {
              data: ` <img height="1" width="1" style="display:none" 
                      src="https://www.facebook.com/tr?id='${window.sessionStorage.getItem(
                "fbPixel"
              )}'&ev=PageView&noscript=1"/>`,
              tag: "noscript",
            },
            {
              data: `(function(c,l,a,r,i,t,y){
                      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                      t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                      y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                      })(window, document, "clarity", "script", '${window.sessionStorage.getItem(
                "clarityId"
              )}');`,
            },
          ]}
        ></Head>
        <Favicon url={window.sessionStorage.getItem("fav_icon")} />
        <Helmet>
          {/* <title>{window.sessionStorage.getItem("title")}</title> */}
        </Helmet>
        <div class="mentalHeaderActive"></div>
        <Suspense fallback={<div></div>}>
          <section>
            <NotificationPopUp />
          </section>
        </Suspense>
        <div class="mentalHeaderActive"></div>
        <span class="mentalToggle">
          <span></span>
        </span>
        <div class="mentalLogo">
          <a href="/">
            <img src={window.sessionStorage.getItem("siteLogo")} alt="" />
          </a>
        </div>
        <div class="mentalMenu">
          <ul class="mentalMenu-ul">
            <li class="menu_item" id="menuitemId1">
              <a href={(urlPath, "/")}>Home</a>
            </li>
            {this.state.headerDataLink
              .filter((a) => {
                return a.isActive === true;
              })
              .map((headerDeatils) => {
                return (
                  <li
                    className="menu_item dropDownArrow"
                    id={"menu_" + headerDeatils.url}
                  >
                    {/* <Link to={headerDeatils.url}>{headerDeatils.headerlinkName}</Link> */}
                    {headerDeatils?.url?.split("-")[0]=="faq" ?
                      <a href={`${urlPath}/${headerDeatils.url}`}>
                        {headerDeatils.headerlinkName}
                      </a> :
                      <a href={(urlPath, "/2-" + headerDeatils.url)}>
                        {headerDeatils.headerlinkName}
                      </a>
                    }
                    {headerDeatils.headerSubList.length != "0" && (
                      <span class="dropArrow"></span>
                    )}
                    {headerDeatils.headerSubList.length != "0" && (
                      <ul class="mentalSubMenu">
                        {headerDeatils.headerSubList.map((data) => (
                          <li>
                            {/* <Link to={data.subUrl}>{data.subName}</Link> */}
                            {/* <a href={(urlPath, "/home/menu/"+data.subUrl)}>{data.subName}</a> */}
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              })}
            <li>
              <a href={(urlPath, "/HealthInfo")}>Health Blog</a>
            </li>
            {window.sessionStorage.getItem("role") === "ROLE_ADMIN" && (
              <li class="menu_item dropDownArrow service-menublock">
                <a href="#">
                  {" "}
                  Admin
                  <i
                    class="fa fa-chevron-down ml-1"
                    style={{ fontSize: "10px" }}
                  ></i>
                </a>
                {/* <span class="dropArrow"></span> */}
                <ul class="mentalSubMenu">
                  <li>
                    <a href="/admin/dashboard">dashboard</a>
                  </li>

                  <li>
                    <a href="#" onClick={() => this.signOutPatientClick()}>
                      Log Out
                    </a>
                  </li>
                </ul>
              </li>
            )}

            {window.sessionStorage.getItem("role") !== "ROLE_DOCTOR" &&
              window.sessionStorage.getItem("role") !== "ROLE_ADMIN" && (
                <li class="menu_item dropDownArrow service-menublock">
                  <a href="#">
                    {" "}
                    Services
                    <i
                      class="fa fa-chevron-down ml-1"
                      style={{ fontSize: "10px" }}
                    ></i>
                  </a>

                  <ul class="mentalSubMenu">
                    {this.state.siteServices.map((data) => (
                      <li class="">{this.getServiceLink(data.serviceName)}</li>
                    ))}
                  </ul>
                </li>
              )}
            <li className=" patientMenuTop menu-role">
              <div
                className="imgshowhide menu-role-link"
                onClick={this.userdropClick}
                ref={(userNode) => {
                  this.userNode = userNode;
                }}
              >
                <span class="showMyName">
                  {" "}
                  Hi {window.sessionStorage.getItem("userName")}
                </span>
                <i
                  class="fa fa-chevron-down ml-1"
                  style={{ fontSize: "10px" }}
                ></i>
              </div>
              {/* <span className=""></span> */}
              {this.state.userdropVisible && (
                <div className="">
                  <Suspense fallback={<div></div>}>
                    <section>
                      <PatientMenu />
                    </section>
                  </Suspense>
                </div>
              )}
            </li>

            <li className="doctorMenuTop menu-role">
              <Link
                className="imgshowhide menu-role-link"
                onClick={this.userdropClick}
                ref={(userNode) => {
                  this.userNode = userNode;
                }}
              >
                <span class="showMyName">
                  {" "}
                  Hi {window.sessionStorage.getItem("userName")}
                </span>
                <i
                  class="fa fa-chevron-down ml-1"
                  style={{ fontSize: "10px" }}
                ></i>
              </Link>

              {/* <span className=""></span> */}
              {this.state.userdropVisible && (
                <div className="">
                  <Suspense fallback={<div></div>}>
                    <section>
                      <DoctorMenu />
                    </section>
                  </Suspense>
                </div>
              )}
            </li>
            {window.sessionStorage.getItem("isLogin") != "true" ? (
              <li>
                <span className="commonButton " onClick={this.loginMenu}>
                  Login
                </span>
              </li>
            ) : (
              ""
            )}
          </ul>
        </div>

        <div class=" signInWrap" id="signInWrapDiv">
          <Login></Login>
        </div>
        <div class=" signInWrap" id="SignupWrap">
          <Signup></Signup>
        </div>
        <div class=" signInWrap " id="ForgotPasswordWrap">
          <ForgotPassword></ForgotPassword>
        </div>
        {/*<Booknow></Booknow>*/}
        <div id="lazyHomeBody_"></div>
        <div className="loader "></div>
      </div>
    );
  }
}
